import { h } from '@debbie/cortex/dist/index.js';
import { useTransactionImport } from '@debbie/cortex/dist/transaction-accounts/index.js';
import React from 'react';
import File from '../File/index.js';
const TransactionImportPreview = (props) => {
    const transactionImportLoadable = useTransactionImport(props.transactionImportId);
    const transactionImport = h.hasData(transactionImportLoadable)
        ? transactionImportLoadable.data
        : null;
    return (React.createElement(React.Fragment, null, transactionImport && (React.createElement(File, { file: {
            fileName: transactionImport.fileName,
            contentType: transactionImport.fileContentType,
            fileId: transactionImport.fileId,
        } }))));
};
export default TransactionImportPreview;
//# sourceMappingURL=TransactionImportPreview.js.map